import React, { FunctionComponent } from 'react'
import { Path, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

/**
 * Inbox icon - used to indicate asynchronous/inbox messaging
 */
export const InboxIcon: FunctionComponent<InboxIconProps> = ({ size = 24, fillColor }) => {
  const { colors } = useTheme()

  return (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none'>
      <Path
        d='M5.78624 19.7182C5.3804 19.7182 5.02824 19.5689 4.72974 19.2702C4.43107 18.9717 4.28174 18.6196 4.28174 18.2137V5.78624C4.28174 5.36874 4.43107 5.01366 4.72974 4.72099C5.02824 4.42816 5.3804 4.28174 5.78624 4.28174H18.2137C18.6312 4.28174 18.9863 4.42816 19.279 4.72099C19.5718 5.01366 19.7182 5.36874 19.7182 5.78624V18.2137C19.7182 18.6196 19.5718 18.9717 19.279 19.2702C18.9863 19.5689 18.6312 19.7182 18.2137 19.7182H5.78624ZM5.78849 18.5192H18.2115C18.3013 18.5192 18.3751 18.4904 18.4327 18.4327C18.4904 18.3751 18.5192 18.3013 18.5192 18.2115V14.727H15.4105C15.1132 15.4302 14.6579 16.0026 14.0447 16.4442C13.4317 16.8859 12.7561 17.1067 12.0177 17.1067C11.2629 17.1067 10.5764 16.8901 9.95824 16.4567C9.3399 16.0234 8.89041 15.4468 8.60974 14.727H5.48074V18.2115C5.48074 18.3013 5.50957 18.3751 5.56724 18.4327C5.6249 18.4904 5.69865 18.5192 5.78849 18.5192ZM12.0225 15.9077C12.5422 15.9077 12.9897 15.7252 13.3652 15.36C13.7409 14.995 14.0102 14.5519 14.173 14.0307C14.2412 13.8494 14.3605 13.7202 14.531 13.6432C14.7017 13.5664 14.8901 13.528 15.0962 13.528H18.5192V5.78849C18.5192 5.69865 18.4904 5.6249 18.4327 5.56724C18.3751 5.50957 18.3013 5.48074 18.2115 5.48074H5.78849C5.69865 5.48074 5.6249 5.50957 5.56724 5.56724C5.50957 5.6249 5.48074 5.69865 5.48074 5.78849V13.528H8.90924C9.10857 13.528 9.29466 13.5664 9.46749 13.6432C9.64049 13.7202 9.75965 13.8494 9.82499 14.0307C9.98915 14.5551 10.2635 14.999 10.648 15.3625C11.0325 15.726 11.4907 15.9077 12.0225 15.9077ZM5.78849 18.5192H5.48074H18.5192H5.78849Z'
        fill={fillColor || colors.iconDefault}
      />
    </Svg>
  )
}

type InboxIconProps = {
  size?: string | number
  fillColor?: string
}
